'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var NthThumbnail = require('@narvar/nth-bit-thumbnail');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var NthThumbnail__default = /*#__PURE__*/_interopDefaultLegacy(NthThumbnail);

const Wrapper = styled__default["default"].div.withConfig({
  componentId: "sc-10ympd-0"
})(_ref => {
  let {
    s
  } = _ref;
  return {
    ...s
  };
});
const Previews = styled__default["default"].div.withConfig({
  componentId: "sc-10ympd-1"
})(_ref2 => {
  let {
    s
  } = _ref2;
  return {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: 24,
    flexWrap: 'wrap',
    ...s
  };
});
const Preview = styled__default["default"].div.withConfig({
  componentId: "sc-10ympd-2"
})(_ref3 => {
  let {
    s
  } = _ref3;
  return {
    position: 'relative',
    ...s
  };
});
styled__default["default"](NthThumbnail__default["default"]).withConfig({
  componentId: "sc-10ympd-3"
})(() => ({
  width: 150,
  display: 'block'
}));

exports.Preview = Preview;
exports.Previews = Previews;
exports.Wrapper = Wrapper;
